// extracted by mini-css-extract-plugin
export var skipAnimation = "_47-0";